import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./Pages/Home";
import About from './Pages/About';
import Contact from './Pages/Contact';
import Footer from './components/Footer';
import CheckCompensation from './Pages/CheckCompensation';
import ScrollToTop from './components/ScrollToTop';


export default function App() {
  return (
    <BrowserRouter>
     <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/check-compensation" element={<CheckCompensation />} /> 

      </Routes>
       <Footer />
    </BrowserRouter>
  );
}
